module.exports = __webpack_public_path__ + "static/img/slogn.b9ce772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/slogn.png
// module id = yKh1
// module chunks = 1